import { Toast as MontaToast } from "@monta/design-system";
import type { ToastClass } from "./types";

const Toast: ToastClass | undefined = MontaToast;

export default Toast;
